import { useApiClient } from '@cldsystems/ws-api-client';
import { useMutation } from '@tanstack/react-query';

import { putReviewDeleteImage } from '@/services/review-images';

const useReviewDeleteImageMutation = () => {
  const { httpClient } = useApiClient();

  return useMutation({
    mutationKey: ['webshopReviewDeleteImage'],
    mutationFn: async ({
      id,
      version,
      imageId,
    }: {
      id: string;
      version: number | string;
      imageId: string;
    }) => {
      return putReviewDeleteImage(httpClient, { id, version, imageId });
    },
  });
};

export default useReviewDeleteImageMutation;
